import React from "react";
import styled from "styled-components";
import { Theme, colors } from "@literati/public-ui-shared-react";
import { Address } from "components/Shipping/shippingTypes";

const CLASS_BASE = "shipping-suggested-address";
export const ShippingSuggestedAddressClassName = {
  BASE: CLASS_BASE,
  SUBMITTED_ADDRESS_SECTION: `${CLASS_BASE}-submitted-address-section`,
  SUBMITTED_ADDRESS: `${CLASS_BASE}-submitted-address`,
  EXPLANATION: `${CLASS_BASE}-explanation`,
  SUGGESTED_ADDRESS_HEADER: `${CLASS_BASE}-suggested-address-header`,
  SUGGESTED_ADDRESS: `${CLASS_BASE}-suggested-address`,
} as const;

export interface ShippingSuggestedAddressProps {
  className?: string;
  submittedAddress: Address;
  suggestedAddress: Address;
}

const AddressSection = ({
  address,
  className = "",
}: {
  address: Address;
  className?: string;
}) => {
  const { street1, street2, city, state, postalCode } = address;
  return (
    <div className={className}>
      <p>{street1}</p>
      <p>{street2}</p>
      <p>
        {city}, {state} {postalCode}
      </p>
    </div>
  );
};

const SubmittedAddressSection = styled.section`
  font-size: 0.875rem;
`;

const SubmittedAddress = styled(AddressSection)`
  font-weight: 700;
`;

const SuggestedAddressHeader = styled.p`
  margin: 0.75rem 0 0;
  font-size: 0.625rem
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.warmGray4};
`;

const Explanation = styled.p`
  margin: 0.5rem 0 0;
`;

const SuggestedAddress = styled(AddressSection)`
  margin: 0.75rem 0 0;
  padding: 1rem;
  background: ${colors.pulpWhite};
  border-radius: 0.375rem;
`;

export const ShippingSuggestedAddress = ({
  className = "",
  suggestedAddress,
  submittedAddress,
}: ShippingSuggestedAddressProps) => {
  const cls = ShippingSuggestedAddressClassName;
  return (
    <Theme>
      <div className={`${cls.BASE} ${className}`}>
        <SubmittedAddressSection className={cls.SUBMITTED_ADDRESS_SECTION}>
          <SubmittedAddress
            address={submittedAddress}
            className={cls.SUBMITTED_ADDRESS}
          />
          <Explanation className={cls.EXPLANATION}>
            The shipping address you entered does not match the suggested
            address provided by the United States Postal Service.
          </Explanation>
        </SubmittedAddressSection>
        <SuggestedAddressHeader className={cls.SUGGESTED_ADDRESS_HEADER}>
          Suggested Address
        </SuggestedAddressHeader>
        <SuggestedAddress
          address={suggestedAddress}
          className={cls.SUGGESTED_ADDRESS}
        />
      </div>
    </Theme>
  );
};

export default ShippingSuggestedAddress;
